import { LoadingTableStats, RefreshableTableStat, RowCountTableStats } from '@ztechapps/webui.data-tools'
import { HorizontalStack } from '@ztechapps/webui.util'
import { formatNumber } from '@ztechapps/common.utils'
import { formatCreditAmount } from '@ztechapps/ai.common'
import { USAGE_CREDIT_DECIMALS } from './constants'
import { useUsageListContext } from './Context'

export const Stats = () => {
  const { usageList } = useUsageListContext()

  if (usageList?.loading) return <LoadingTableStats />

  return (
    <HorizontalStack gap={3}>
      <RowCountTableStats label="usage records" />
      <UsageTotalsStats />
    </HorizontalStack>
  )
}

const UsageTotalsStats = () => {
  const { usageTotals, currencyFormat, onRefresh } = useUsageListContext()
  const { document: totals, loading } = usageTotals
  const symbol = currencyFormat?.symbol

  // Routed through the context's `onRefresh` (usage list + totals + `creditBalance`) rather than
  // `usageTotals.refetch()` alone, so clicking any of these stats also refreshes the Available
  // balance shown beside the table, so the balance and the usage table can never disagree after a refresh.
  return (
    <HorizontalStack gap={3}>
      <RefreshableTableStat
        label="Total Tokens:"
        value={formatNumber(totals?.totalTokens)}
        loading={loading}
        onRefresh={() => onRefresh()}
        busyText="Calculating..."
        className="fw-bold text-decoration-none"
      />

      {/* Table is Debit-only (`GetAiCreditTransactionListTotals` scopes to `type: Debit`), so
          `totalCredits` sums signed-negative rows — shown as magnitude ("credits consumed") to
          match the per-row `credits` column; see ListRow.tsx's comment. */}
      <RefreshableTableStat
        label="Total Credits:"
        value={formatCreditAmount(Math.abs(totals?.totalCredits ?? 0), { symbol, decimals: USAGE_CREDIT_DECIMALS })}
        loading={loading}
        onRefresh={() => onRefresh()}
        busyText="Calculating..."
        className="fw-bold text-decoration-none"
      />

      <RefreshableTableStat
        label="Total Markup:"
        value={formatCreditAmount(totals?.totalMarkup, { symbol, decimals: USAGE_CREDIT_DECIMALS })}
        loading={loading}
        onRefresh={() => onRefresh()}
        busyText="Calculating..."
        className="fw-bold text-decoration-none"
      />
    </HorizontalStack>
  )
}
